import { createStyles } from '@mantine/core';
var useStyles = createStyles(function () {
  return {
    root: {
      width: "100%",
      height: "100%",
      position: "relative"
    }
  };
});
export { useStyles as default };